import React, { FC } from 'react';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { useTranslations } from '@lang';
import BaseSectionHeader from '@common/components/SectionHeader';
import BaseMarkdown from '@common/components/Markdown';

const SectionHeader = styled(BaseSectionHeader)`
  text-align: left;
  margin-bottom: 15px;
  margin-top: 15px;

  ${media.lg`
    margin-top: 80px;
  `}
`;

const Markdown = styled(BaseMarkdown)`
  line-height: 26px;
  padding-bottom: 30px;
`;

type SpaTermsAndConditionsProps = {
  entityTermsAndConditions?: string;
  spaTermsAndConditions: string;
};

export const SpaTermsAndConditions: FC<SpaTermsAndConditionsProps> = ({
  entityTermsAndConditions = '',
  spaTermsAndConditions = '',
}) => {
  const { t } = useTranslations();

  return entityTermsAndConditions || spaTermsAndConditions ? (
    <>
      <SectionHeader id="termsAndConditions">{t('homepage.termsAndConditions')}</SectionHeader>
      {entityTermsAndConditions && <Markdown text={entityTermsAndConditions} />}
      {spaTermsAndConditions && <Markdown text={spaTermsAndConditions} />}
    </>
  ) : null;
};
